import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
const SnackbarContext = createContext();
const SnackbarProvider = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (message_0, t2) => {
      const severity_0 = t2 === undefined ? "success" : t2;
      setMessage(message_0);
      setSeverity(severity_0);
      setOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const showSnackbar = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      showSnackbar,
      handleClose
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      vertical: "bottom",
      horizontal: "center"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      closeButton: _temp2
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== message || $[6] !== severity) {
    t6 = <Alert onProgress={_temp} icon={false} onClose={handleClose} severity={severity} variant="filled" slots={t5}>{message}</Alert>;
    $[5] = message;
    $[6] = severity;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== message || $[9] !== open || $[10] !== t6) {
    t7 = <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={t4} message={message}>{t6}</Snackbar>;
    $[8] = message;
    $[9] = open;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== t7) {
    t8 = <SnackbarContext.Provider value={t3}>{children}{t7}</SnackbarContext.Provider>;
    $[12] = children;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function useToastContext() {
  return useContext(SnackbarContext);
}
export { SnackbarProvider, useToastContext };
function _temp() {
  return false;
}
function _temp2() {
  return <></>;
}